<template>
  <div class="public-dashboard-item" @click="$emit('click')">
    <div class="item-info">
      <h3 class="item-title">{{ dashboard.title }}</h3>
      <div class="item-stats">
        <v-icon size="16" class="stat-icon">mdi-view-grid</v-icon>
        <span class="stat-text">{{ dashboard.charts }}/{{ dashboard.totalCharts }}</span>
      </div>
    </div>
    <button class="item-menu-btn" @click.stop="$emit('menu')">
      <v-icon size="24">mdi-dots-vertical</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "PublicDashboardItem",
  props: {
    dashboard: {
      type: Object,
      required: true,
    },
  },
};
</script>

